import { Component, HostListener, Renderer2, Inject } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { Delay } from './source/utils/delay';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { LoginService } from './source/services/login/login.service';
import { GamesService } from './source/services/games/games.service';
import * as loginActions from './source/appstates/loginstates/loginActions'
import * as appState from './source/appstates/appState';
import { Store } from '@ngrx/store';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/operators';
import { LoaderComponent } from './media/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { CommondataService } from './source/services/games/commondata.service';
import { SlotsService } from './source/services/slotsservice/slots.service';
import { LoginState } from './source/appstates/loginstates/loginState';

declare var $: any;
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FormsModule, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  productid: any
  constructor(private platform: Platform, private splashScreen: SplashScreen, private common: CommondataService, private statusBar: StatusBar, private store: Store<appState.AppState>, private slotsservice: SlotsService,
    private loginService: LoginService, private gameservice: GamesService, private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, private router: Router) {
    // this.gameservice.fetchAllGames();
    this.store.select("loginState").subscribe((loginState: LoginState) => {
      if (loginState?.playerLoggedIn) {
        if (loginState.playerLoggedIn.loggedIn) {
          this.gameservice.fetchAllGames11(true)
        } else {
          this.gameservice.fetchAllGames11(false)
        }
      }


    })
    // setInterval(() => this.detectDevTools(), 1000);


    // this.platform.ready().then(() => {
    //   if (this.platform.is('cordova')) {
    //     this.statusBar.styleDefault();
    //     this.splashScreen.hide();
    //   }
    //   // this.initializeApp();
    // });
    if (document.referrer == `https://test.endorphina.network/`) {
      window.parent.close()
      window.close()
    }

    const queryString = window.location.href;
    const urlParams = new URL(queryString).searchParams;
    const product = urlParams.get('type');
    const productID: any = urlParams.get('ID') || urlParams.get('id') || urlParams.get('Id');
    const clickId: any = urlParams.get("clickid");
    this.productid = productID
    console.log(queryString)
    console.log(productID)
    if (product === "affiliate") {
      localStorage.setItem("affCid", productID)
      localStorage.setItem("affcheckid", clickId)
      this.gethitcountlist()
    }


  }
  // @HostListener('document:keydown', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent): boolean {
  //   if (
  //     event.key === 'F12' ||
  //     (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'i') ||
  //     (event.ctrlKey && event.key.toLowerCase() === 'u')
  //   ) {
  //     event.preventDefault();
  //     return false;
  //   }
  //   return true;
  // }
  // detectDevTools() {
  //   const threshold = 160;
  //   const start = new Date().getTime();
  //   debugger;
  //   const end = new Date().getTime();
  //   if (end - start > threshold) {
  //     alert('DevTools is open. Please close it to continue.');
  //   }
  // }
  gethitcountlist() {
    let body = {
      "campaignId": this.productid,
      "campaignType": "affiliate",
      "languageCode": "en"
    }
    this.loginService.getHitcount(body).subscribe((data: any) => console.log(data))
  }
  ngOnInit(): void {
    // this.router.events
    //   .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
    //   .subscribe(event => {
    //     this.updateCanonicalUrl(`https://gambaji.com${event.urlAfterRedirects}`);
    //   });

  }

  // updateCanonicalUrl(url: string) {
  //   const link: HTMLLinkElement | null = this.document.querySelector<HTMLLinkElement>("link[rel='canonical']");
  //   if (link) {
  //     link.href = url;
  //   } else {
  //     const newLink = this.renderer.createElement('link') as HTMLLinkElement;
  //     newLink.setAttribute('rel', 'canonical');
  //     newLink.setAttribute('href', url);
  //     this.renderer.appendChild(this.document.head, newLink);
  //   }
  // }



  initializeApp() {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get("sessionId");
    if (sessionId) {
      const body: any = {
        success: true,
        sessionId: sessionId
      };
      this.store.dispatch(new loginActions.LoginSuccess(body));
    }

    // this.platform.ready().then(() => {
    //   if (this.platform.is('cordova')) {
    //     this.statusBar.styleDefault();
    //     this.splashScreen.hide();
    //   }
    // });
    // window.addEventListener('beforeunload', () => {
    //   sessionStorage.removeItem('visitedPaths');
    // });
  }
  ngAfterViewInit(): void {
    // const preloader = document.getElementById('preloader');
    // if (preloader) {
    //   setTimeout(() => {
    //     preloader.style.display = 'none';
    //   }, 1500);
    // }
  }

}
